<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <ellipse cx="10" cy="9.99995" rx="7.5" ry="7.5" fill="#70C4DF" />
        <rect x="10" y="6.66667" width="0.00833321" height="0.00833368" stroke="white" stroke-width="1.5"
            stroke-linejoin="round" />
        <path d="M10 10V13.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>